import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "Créer une carte cadeau ogloba", -1)
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "justify-center" }
const _hoisted_4 = { class: "mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  style: {"word-wrap":"break-word"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "flex mt-[1.5rem]" }

import ApiService from "@/_services/api.service";
import {onMounted, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import router from "@/router";
import CustomButton from "@/components/forms/CustomButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOglobaOrder',
  setup(__props) {

let products = ref([]);
let product: {} = ref();
let validAmountVoucherEror = ref('');
let amount = ref();

onMounted(async () => {
    await fetchOglobaProducts();
})

async function fetchOglobaProducts() {
    try {
        const response = await ApiService.get('admin/get-ogloba-products');
        products.value = response.data.data.map((item: never) => {
            return {
                label: item.productName, value: item, attrs: {disabled: !item.allowedActivate}
            };
        });
    } catch (error) {
        swal.error('Une erreur est survenue');
    }
}

async function submitHandler(data, formNode) {
    return ApiService.post("/admin/reserve-ogloba-product", {
        itemCode: data.product.itemCode,
        amount: parseFloat(data.amount),
        quantity: parseInt(data.quantity)
    }).then(({data}) => {
        swal.success("", "Les cartes ont été créées !");
        router.push({name: 'listOglobaOrder'});
    }).catch(({response}) => {
        swal.error(response?.data?.errors[0]?.message);
    });
}
function validAmountVoucher(node) {
    const amountValue = node.value;
    validAmountVoucherEror.value = '';
    if (product.value.isFixValue) {
        return true;
    }
    if (product.value.reloadList?.length) {
        if (product.value.reloadList.includes(amountValue)) {
            return true;
        }
        validAmountVoucherEror.value = 'La valeur ne fait pas partie de la liste autorisée pour cette enseigne.';
        return false;
    }
    if (amountValue <= product.value.maxCardAmount && amountValue >= product.value.minCardAmount) {
        return true;
    }
    validAmountVoucherEror.value = 'La valeur doit être entre ' + product.value.minCardAmount + ' et ' + product.value.maxCardAmount;
    return false;
}

watch(
    product,
    (value) => {
        amount.value = null;
        if (value && value.isFixValue) {
            amount.value = value.faceValue;
        }
    });


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: { name: 'listOglobaOrder' },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FormKit, {
            type: "form",
            value: true,
            actions: false,
            "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement.",
            onSubmit: submitHandler
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                type: "autocomplete",
                modelValue: _unref(product),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(product) ? (product).value = $event : product = $event)),
                name: "product",
                label: "Enseigne *",
                placeholder: "Choisissez une enseigne",
                validation: "required",
                options: _unref(products),
                "validation-messages": {
                                  required: 'Veuillez sélectionner une enseigne.',
                                }
              }, null, 8, ["modelValue", "options", "validation-messages"]),
              (_unref(product))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_FormKit, {
                      modelValue: _unref(amount),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(amount) ? (amount).value = $event : amount = $event)),
                      type: "number",
                      step: "any",
                      label: "Valeur faciale",
                      name: "amount",
                      disabled: _unref(product).isFixValue,
                      "validation-rules": { validAmountVoucher: validAmountVoucher },
                      validation: "validAmountVoucher|required",
                      "validation-messages": {
                       validAmountVoucher: _unref(validAmountVoucherEror),
                       required: 'Veuillez sélectionner une valeur faciale'
              }
                    }, null, 8, ["modelValue", "disabled", "validation-rules", "validation-messages"]),
                    (!_unref(product).isFixValue &&  _unref(product).reloadList?.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Valeurs autorisées: " + _toDisplayString(_unref(product).reloadList.toString()), 1))
                      : _createCommentVNode("", true),
                    (!_unref(product).isFixValue &&  !_unref(product).reloadList?.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Valeurs autorisées: " + _toDisplayString(_unref(product).minCardAmount) + " à " + _toDisplayString(_unref(product).maxCardAmount), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createVNode(_component_FormKit, {
                type: "number",
                number: "integer",
                label: "Quantité",
                name: "quantity",
                value: "1",
                validation: "required|min:1|max:20",
                "validation-messages": {
                       required: 'Veuillez saisir une quantité',
                       min:'Quantité ne peut pas être inférieure à 1.',
                       max:'Quantité ne peut pas être supérieure à 20.'
                      }
              }, null, 8, ["validation-messages"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_FormKit, {
                  type: "submit",
                  label: "Créer",
                  class: "btn",
                  "prefix-icon": "check"
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}
}

})